import React, { useState, useContext, useEffect, Fragment } from "react";
import { UrlServicesContext } from "components/UrlServicesContext";
import { Redirect } from "react-router-dom";

// @material-ui/core components
import { makeStyles } from "@mui/styles";
// core components
import GridItem from "components/Grid/GridItem.js";
import GridContainer from "components/Grid/GridContainer.js";
import { AttachMoney, Search, FileDownload, Close } from "@mui/icons-material";
import Card from "components/Card/Card.js";
import CardBody from "components/Card/CardBody.js";
import clsx from "clsx";
import { DataGrid, gridClasses } from "@mui/x-data-grid";
import axios from "axios";
import { TextField, Box, Grid, Alert } from "@mui/material";
import Moment from "moment";
import { DemoContainer } from "@mui/x-date-pickers/internals/demo";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import dayjs from "dayjs";

import StatusAdmin from "views/dialog/StatusAdmin";
import EditClientAdmin from "views/dialog/EditClientAdmin";
import ViewstrasactionsAdmin from "views/dialog/ViewstrasactionsAdmin";
import ViewExcelDownload from "views/dialog/ViewExcelDownload";
import LoadCompanies from "components/services/LoadCompanies";

import loaderGif from "assets/img/loading.gif";
import noDataImg from "assets/img/undraw_House_searching_re_stk8.png";

import {
  cardBodyStyle,
  ButtonTableGrid1,
} from "assets/jss/material-dashboard-react/components/cardBodyStyle";

const useStyles = makeStyles(cardBodyStyle);

export default function TransactionsSuperAdmin() {
  const classes = useStyles();

  const [idRow, setIdRow] = useState("");
  const [openExcel, setOpenExcel] = useState(false);
  const [rows, setRows] = useState([]);
  const [openStatus, setOpenStatus] = useState(false);
  const [openViewsTransactions, setOpenViewsTransactions] = useState(false);
  const [openEdit, setOpenEdit] = useState(false);
  const [loader, setLoader] = useState(true);
  const [error, setError] = useState(false);
  const [mensageSystem, setMensageSystem] = useState("");
  const [returnLogin, setReturnLogin] = React.useState(false);
  const [searchText, setSearchText] = useState("");
  const [rowsResponse, setRowsResponse] = useState([]);
  const [toDate, setToDate] = useState();
  const [fromDate, setFromDate] = useState();
  const [pay, setPay] = useState(0);
  const [payPercentage, setPayPercentage] = useState(0);
  const [totalRows, setTotalRows] = useState(0);

  const { urlServices, UserAuth } = useContext(UrlServicesContext);

  let keyAuthorization = UserAuth.Session;

  const [values, setValues] = useState({
    companyData: "",
  });

  const [state] = useState({
    columns: [
      {
        headerName: "COD.",
        field: "code",
        width: 60,
        headerAlign: "center",
        align: "center",
        headerClassName: "super-app-theme--header",
        cellClassName: (params) => {
          return clsx("super-app", {
            celAll: params.value,
          });
        },
        renderCell: (params) => {
          return (
            <Alert severity="info" icon={false}>
              <b style={{ fontSize: 10 }}>{params.value} </b>
            </Alert>
          );
        },
        sortable: false,
        hideable: false,
      },
      {
        headerName: "Empresa",
        field: "companyName",
        headerClassName: "super-app-theme--header",
        headerAlign: "center",
        renderCell: (params) => {
          return <b style={{ fontSize: 12 }}>{params.value} </b>;
        },
        cellClassName: (params) => {
          return clsx("super-app", {
            celAll: params.value,
          });
        },
        flex: 1,
        sortable: false,
        filtering: false,
        hideable: false,
      },
      {
        headerName: "Cliente",
        field: "client.allNames",
        headerClassName: "super-app-theme--header",
        headerAlign: "center",
        renderCell: (params) => {
          return (
            <span style={{ fontSize: 12 }}>{params.row.client.allNames} </span>
          );
        },
        cellClassName: (params) => {
          return clsx("super-app", {
            celAll: params.value,
          });
        },
        flex: 1,
        sortable: false,
        filtering: false,
        hideable: false,
      },
      {
        headerName: "Creación",
        field: "createdAt",
        headerClassName: "super-app-theme--header",
        headerAlign: "center",
        renderCell: (params) => {
          return <span>{Moment(params.value).format("DD-MM-YYYY")} </span>;
        },
        cellClassName: (params) => {
          return clsx("super-app", {
            celAll: params.value,
          });
        },
        align: "center",
        width: 110,
        sortable: false,
        filtering: false,
        hideable: false,
      },
      {
        field: "action1",
        headerName: "----",
        headerAlign: "center",
        headerClassName: "super-app-theme--header",
        width: 150,
        align: "center",
        renderCell: (params) => (
          <ButtonTableGrid1
            onClick={openViewsTransactionsValue(params)}
            style={{ margin: "12px 0", fontSize: 10 }}
          >
            Ver transacción
          </ButtonTableGrid1>
        ),
      },
      {
        headerName: "Total",
        field: "productsJson",
        headerClassName: "super-app-theme--header",
        headerAlign: "center",
        renderCell: (params) => {
          return (
            <b>
              $
              {params.row.productsJson.length > 0
                ? params.row.productsJson[0].typePay === "CR"
                  ? parseFloat(params.row.productsJson[0].payMonthTotal)
                  : parseFloat(params.row.productsJson[0].payTotal)
                : 0}{" "}
            </b>
          );
        },
        cellClassName: (params) => {
          return clsx("super-app", {
            celAll: params.value,
          });
        },
        align: "center",
        width: 90,
        sortable: false,
        filtering: false,
        hideable: false,
      },
      {
        headerName: "Estado",
        field: "status",
        headerClassName: "super-app-theme--header",
        headerAlign: "center",
        renderCell: (params) => {
          const cash =
            params.row.cashPaymentTransactions.length > 0 ? true : false;

          let dataFinal = cash;

          if (!cash) {
            const dataFilterPay = params.row.paymentTransactions.filter(
              (item) => item.status === 1
            );

            dataFinal = dataFilterPay.length > 0 ? true : false;
          }

          return (
            <b style={{ fontSize: 10, color: dataFinal ? "green" : "red" }}>
              {dataFinal ? "PAGADO" : "PENDIENTE"}
            </b>
          );
        },
        cellClassName: (params) => {
          return clsx("super-app", {
            celAll: params.value,
          });
        },
        align: "center",
        width: 90,
        sortable: false,
        filtering: false,
        hideable: false,
      },
    ],
  });

  const handleFromDateChange = (data) => {
    setFromDate(data);

    // Si la nueva fecha "Desde" es mayor que "Hasta", restablece "Hasta"
    if (data && toDate && data.isAfter(toDate)) {
      setToDate(null);
    } else {
      setToDate(null);
    }
  };

  const handleToDateChange = (data) => {
    setToDate(data);

    let transformedRows = values.companyData ? rows : rowsResponse;

    if (fromDate && data) {
      // Convertir las fechas de fromDate y toDate a formato 'YYYY-MM-DD'
      const fromDateValue = dayjs(fromDate).format("YYYY-MM-DD");
      const toDateValue = dayjs(data).format("YYYY-MM-DD");

      // Filtrar los registros por el rango de fechas
      transformedRows = transformedRows.filter((item) => {
        const createdAt = dayjs(item.createdAt).format("YYYY-MM-DD");

        // Verifica si createdAt está dentro del rango entre fromDate y toDate
        return createdAt >= fromDateValue && createdAt <= toDateValue;
      });
    }

    let SUM = 0;

    if (values.companyData && transformedRows.length > 0) {
      SUM = transformedRows.reduce((total, val) => {
        const payTotal = parseFloat(val.productsJson[0]?.payTotal) || 0;
        return total + payTotal;
      }, 0);
    }

    setTotalRows(values.companyData ? transformedRows.length : 0);
    setPay(values.companyData ? SUM.toFixed(2) : 0);
    setPayPercentage(
      values.companyData
        ? (
            (parseFloat(SUM).toFixed(2) *
              parseFloat(values.companyData.percentage)) /
            100
          ).toFixed(2)
        : 0
    );

    setRows(transformedRows);
  };

  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "smooth" });
    RefreshTable();
  }, []);

  // Función para eliminar acentos de una cadena de texto
  const removeAccents = (str) => {
    return str.normalize("NFD").replace(/[\u0300-\u036f]/g, "");
  };

  const handleSearchChange = (event) => {
    const value = event.target.value; // Obtener el valor del input
    setSearchText(value); // Actualizar el estado del texto de búsqueda

    // Filtrar los datos según el valor de búsqueda
    if (value.trim() !== "") {
      const resultSearch = rowsResponse.filter(
        (item) =>
          removeAccents(item.user.allNames.toLowerCase()).includes(
            removeAccents(value.toLowerCase())
          ) ||
          removeAccents(item.client.allNames.toLowerCase()).includes(
            removeAccents(value.toLowerCase())
          ) ||
          item.code.toString().includes(value)
      );
      setRows(resultSearch);
    } else {
      setRows(rowsResponse); // Restaurar los datos originales si no hay búsqueda
    }
  };

  const RefreshTable = async () => {
    setSearchText("");
    setLoader(true);

    try {
      const response = await axios.get(
        `${urlServices}clients-transaction/list/companies-total`,
        {
          headers: {
            Authorization: "Bearer " + keyAuthorization,
          },
        }
      );

      if (response.status === 200) {
        let transformedRows = response.data.map((data) => {
          let dependents = data.dependentsJson
            ? parseJsonArray(data.dependentsJson)
            : null;
          let products = parseJsonArray(data.productsJson);

          return {
            ...data,
            productsJson: products,
            dependentsJson: dependents,
            companyName: products[0]?.company
              ? products[0].company
              : data.user?.company?.name,
            detailsCancel: data.detailsCancel
              ? JSON.parse(data.detailsCancel)
              : null,
          };
        });

        setRows(transformedRows);
        setRowsResponse(transformedRows);
      }
    } catch (error) {
      if (error.response?.status === 401) {
        setMensageSystem("La sesión ha expirado, vuelva a iniciar sesión ...");
        setError(true);
        setTimeout(() => {
          localStorage.clear();
          setReturnLogin(true);
        }, 4000);
      } else if (error.response?.status === 500) {
        setRows([]);
        setMensageSystem("Error en la consulta con el servidor.");
        setError(true);
      } else {
        console.error("Error en la solicitud:", error);
        setRows([]);
        setMensageSystem("Error al realizar la solicitud.");
        setError(true);
      }
    } finally {
      setLoader(false);
    }
  };

  // Función para parsear cadenas JSON y asegurar que sean arrays
  const parseJsonArray = (jsonString) => {
    try {
      const parsed = JSON.parse(jsonString);
      return Array.isArray(parsed) ? parsed : [];
    } catch (error) {
      console.error("Error parsing JSON:", error);
      return [];
    }
  };

  const openViewsTransactionsValue = (data) => () => {
    setIdRow(data);
    setOpenViewsTransactions(true);
  };

  const changeCompany = (data) => {
    setValues({
      ...values,
      companyData: data !== null ? data : null,
    });

    setFromDate(null);
    setToDate(null);

    const filteredRows = data
      ? rowsResponse.filter((item) => item.companyId === data.id)
      : rowsResponse;

    setRows(filteredRows);
  };

  const changeDeleteCompany = () => {
    setValues({
      ...values,
      companyData: null,
    });

    setRows(rowsResponse);
  };

  const handleFromDateDelete = (data) => {
    setFromDate(null);
    setToDate(null);

    const filteredRows = values.companyData
      ? rowsResponse.filter((item) => item.companyId === values.companyData.id)
      : rowsResponse;

    setRows(filteredRows);
  };

  const handleToDateDelete = (data) => {
    setToDate(null);

    const filteredRows = values.companyData
      ? rowsResponse.filter((item) => item.companyId === values.companyData.id)
      : rowsResponse;

    setRows(filteredRows);
  };

  const openExcelValue = () => () => {
    setOpenExcel(true);
  };

  const handleCloseExcel = () => {
    setOpenExcel(false);
  };

  const handleCloseViewsDependents = () => setOpenViewsTransactions(false);
  const handleCloseStatus = () => setOpenStatus(false);
  const handleCloseEdit = () => setOpenEdit(false);

  if (returnLogin) {
    return <Redirect to="/" />;
  }

  return (
    <GridContainer>
      <GridItem xs={12} sm={12} md={12}>
        <div className={classes.cardTitleBlack}>
          <AttachMoney className={classes.iconFilter} /> Listado de
          transacciones de las empresas
        </div>
        <Card>
          <CardBody>
            {error ? <Alert severity="error">{mensageSystem}</Alert> : ""}
            {loader ? (
              <Grid container spacing={2}>
                <Grid item xs={12} sm={12}>
                  <center>
                    <img
                      alt="loaderGif"
                      src={loaderGif}
                      style={{ width: 60, margin: "20% 0" }}
                    />
                  </center>
                </Grid>
              </Grid>
            ) : (
              <Fragment>
                <Grid container spacing={2}>
                  <Grid item xs={12} sm={12}>
                    <div
                      className={classes.cardTitleBlack}
                      style={{ fontSize: 14 }}
                    >
                      Reporte:
                    </div>
                  </Grid>
                  <Grid item xs={12} sm={6}>
                    {/* Campo de búsqueda */}
                    <TextField
                      variant="outlined"
                      value={searchText}
                      onChange={handleSearchChange}
                      sx={{ mb: 2, width: 300 }}
                      size="small"
                      InputProps={{
                        startAdornment: (
                          <Search
                            position="start"
                            style={{
                              color: "gray",
                              fontSize: 22,
                              marginRight: 10,
                            }}
                          />
                        ),
                      }}
                      fullWidth
                      placeholder="Buscar cliente..."
                      autoComplete="off"
                    />
                  </Grid>
                  <Grid item xs={12} sm={6} sx={{ marginTop: 1 }}>
                    <ButtonTableGrid1
                      onClick={openExcelValue()}
                      style={{ backgroundColor: "green", float: "right" }}
                      startIcon={<FileDownload style={{ fontSize: 14 }} />}
                    >
                      Excel
                    </ButtonTableGrid1>
                  </Grid>
                  <Grid item xs={12} sm={12} sx={{ mt: -1, mb: 1 }}>
                    <Alert severity="info">
                      Si desea saber el porcentaje de ganancia de un cliente por
                      sus ventas realizadas, debes seleccionar el combo de{" "}
                      <b>EMPRESAS</b> + <b>FECHA DESDE</b> + <b>FECHA HASTA</b>.
                    </Alert>
                  </Grid>
                  <Grid item xs={12} sm={4} sx={{ mt: -2 }}>
                    <LoadCompanies
                      value={values.companyData}
                      refresh={changeCompany}
                      reports={true}
                    />
                    {values.companyData && (
                      <b
                        style={{
                          marginTop: 2,
                          fontSize: 10,
                          color: "red",
                          cursor: "pointer",
                        }}
                        onClick={changeDeleteCompany}
                      >
                        <Close sx={{ fontSize: 18, verticalAlign: "middle" }} />{" "}
                        ELIMINAR FILTRO
                      </b>
                    )}
                  </Grid>
                  <Grid item xs={12} md={3} sx={{ mt: -2 }}>
                    <LocalizationProvider dateAdapter={AdapterDayjs}>
                      <DemoContainer components={["DatePicker"]}>
                        <DatePicker
                          name="fromDate"
                          label="Desde"
                          value={fromDate}
                          onChange={(newValue) =>
                            handleFromDateChange(newValue)
                          }
                          format="DD/MM/YYYY"
                          sx={{
                            "& .MuiButtonBase-root": {
                              color: "#333",
                            },
                            width: "100%",
                            background: "#FFFFFF",
                          }}
                          slotProps={{
                            textField: {
                              // helperText: "DD/MM/YYYY",
                              //  required: true,
                              size: "small",
                            },
                          }}
                        />
                      </DemoContainer>
                    </LocalizationProvider>
                    {fromDate && (
                      <b
                        style={{
                          marginTop: 2,
                          fontSize: 10,
                          color: "red",
                          cursor: "pointer",
                        }}
                        onClick={handleFromDateDelete}
                      >
                        <Close sx={{ fontSize: 18, verticalAlign: "middle" }} />{" "}
                        ELIMINAR FILTRO
                      </b>
                    )}
                  </Grid>
                  <Grid item xs={12} md={3} sx={{ mt: -2 }}>
                    <LocalizationProvider dateAdapter={AdapterDayjs}>
                      <DemoContainer components={["DatePicker"]}>
                        <DatePicker
                          name="toDate"
                          label="Hasta"
                          value={toDate}
                          onChange={(newValue) => handleToDateChange(newValue)}
                          format="DD/MM/YYYY"
                          sx={{
                            "& .MuiButtonBase-root": {
                              color: "#333",
                            },
                            width: "100%",
                            background: "#FFFFFF",
                          }}
                          slotProps={{
                            textField: {
                              // helperText: "DD/MM/YYYY",
                              //  required: true,
                              size: "small",
                            },
                          }}
                          disabled={fromDate ? false : true}
                          minDate={fromDate ? fromDate : null}
                        />
                      </DemoContainer>
                    </LocalizationProvider>
                    {toDate && (
                      <b
                        style={{
                          marginTop: 2,
                          fontSize: 10,
                          color: "red",
                          cursor: "pointer",
                        }}
                        onClick={handleToDateDelete}
                      >
                        <Close sx={{ fontSize: 18, verticalAlign: "middle" }} />{" "}
                        ELIMINAR FILTRO
                      </b>
                    )}
                  </Grid>
                  <Grid
                    item
                    xs={12}
                    md={12}
                    sx={{
                      display:
                        values.companyData && fromDate && toDate
                          ? "block"
                          : "none",
                    }}
                  >
                    <Grid
                      container
                      sx={{
                        mt: 2,
                        mb: 2,
                        p: 3,
                        border: "1px solid #ccc",
                        background: "rgb(255, 244, 229)",
                      }}
                    >
                      <Grid item xs={12} md={12} sx={{ mb: 1 }}>
                        <div
                          className={classes.cardTitleBlack}
                          style={{ fontSize: 20 }}
                        >
                          Transacciones y ventas del cliente
                        </div>
                      </Grid>
                      <Grid item xs={12} md={12}>
                        <b style={{ fontWeight: 500, color: "#000" }}>
                          Cliente:
                        </b>{" "}
                        <b
                          style={{
                            fontWeight: "bold",
                            color: "#000",
                            fontSize: 16,
                          }}
                        >
                          {values.companyData ? values.companyData.name : ""}{" "}
                        </b>
                      </Grid>
                      <Grid item xs={12} md={3}>
                        <b style={{ fontWeight: 500, color: "#000" }}>
                          Porcentaje de ganancia:{" "}
                        </b>
                        <span
                          style={{
                            padding: 6,
                            borderRadius: 5,
                            background: "orange",
                            color: "#000",
                            textAlign: "center",
                            fontWeight: "bold",
                          }}
                        >
                          {values.companyData
                            ? values.companyData.percentage
                            : 0}
                          %
                        </span>
                      </Grid>
                      <Grid item xs={12} md={3}>
                        <b style={{ fontWeight: 500, color: "#000" }}>
                          Total de transacciones:
                        </b>{" "}
                        <b
                          style={{
                            fontWeight: "bold",
                            color: "#000",
                            fontSize: 16,
                          }}
                        >
                          {totalRows}
                        </b>
                      </Grid>
                      <Grid item xs={12} md={3}>
                        <b style={{ fontWeight: 500, color: "#000" }}>
                          Total en ventas:{" "}
                        </b>{" "}
                        <b
                          style={{
                            fontWeight: "bold",
                            color: "#000",
                            fontSize: 16,
                          }}
                        >
                          ${pay}{" "}
                        </b>
                      </Grid>
                      <Grid item xs={12} md={3}>
                        <span
                          style={{
                            borderRadius: 5,
                            marginTop: 10,
                            padding: 10,
                            background: "rgb(237, 247, 237)",
                            border: "1px solid green",
                          }}
                        >
                          <b style={{ fontWeight: 500, color: "#000" }}>
                            Total a pagar del{" "}
                            {values.companyData
                              ? values.companyData.percentage
                              : 0}
                            %:
                          </b>{" "}
                          <b
                            style={{
                              fontWeight: "bold",
                              color: "#000",
                              fontSize: 16,
                            }}
                          >
                            ${payPercentage}{" "}
                          </b>
                        </span>
                      </Grid>
                      <Grid item xs={12} md={12}>
                        <Alert
                          severity="warning"
                          sx={{ mt: 2, background: "bisque" }}
                        >
                          Para más detalle puede descargar el excel.
                        </Alert>
                      </Grid>
                    </Grid>
                  </Grid>
                </Grid>
                <Grid container>
                  {rows.length > 0 ? (
                    <Grid item xs={12} sm={12}>
                      <Box
                        sx={{
                          "& .super-app.celAll": {
                            fontSize: 12,
                            //backgroundColor: 'rgba(255, 7, 0, 0.55)',
                          },
                          "& .super-app.celActions": {
                            backgroundColor: "rgb(242, 242, 242)",
                          },
                          "& .super-app-theme--header": {
                            backgroundColor: "rgb(242, 242, 242)",
                            fontSize: 12,
                          },
                          "& .super-app-theme--header-mayuscula": {
                            backgroundColor: "rgb(242, 242, 242)",
                            fontSize: 10,
                          },
                          marginTop: 2,
                        }}
                      >
                        <DataGrid
                          rows={rows}
                          columns={state.columns}
                          loading={loader}
                          initialState={{
                            pagination: {
                              paginationModel: { page: 0, pageSize: 10 },
                            },
                          }}
                          pageSizeOptions={[5, 10, 20, 50]}
                          disableRowSelectionOnClick={true}
                          checkboxSelection={false}
                          sx={{
                            [`& .${gridClasses.cell}`]: {
                              display: "flex",
                              alignItems: "center", // Alineación vertical
                              // justifyContent: 'center', // Alineación horizontal
                              wordWrap: "break-word !important",
                              whiteSpace: "normal !important",
                            },
                            /* [`& .${gridClasses.columnHeaderTitle}`]: {
                                  display: 'flex',
                                  alignItems: 'center',
                                  justifyContent: 'center',
                                },*/
                          }}
                          getRowHeight={() => "auto"}
                          // autoHeights
                          autoWidth
                        />
                      </Box>
                    </Grid>
                  ) : (
                    <Grid item xs={12} sm={12}>
                      <center>
                        <img
                          alt="loaderGif"
                          src={noDataImg}
                          style={{ width: 300, marginTop: 50 }}
                        />
                        <br></br>
                        <b style={{ fontSize: 18, margin: "5px 0 70px 0" }}>
                          No hay registros para mostrar
                        </b>
                      </center>
                    </Grid>
                  )}
                </Grid>
              </Fragment>
            )}
          </CardBody>
        </Card>
      </GridItem>
      {openStatus && (
        <StatusAdmin
          open={openStatus}
          exit={handleCloseStatus}
          id={idRow}
          callBackRefresh={RefreshTable}
          path="clients"
        />
      )}
      {openEdit && (
        <EditClientAdmin
          open={openEdit}
          exit={handleCloseEdit}
          callBackRefresh={RefreshTable}
          id={idRow}
        />
      )}
      {openViewsTransactions && (
        <ViewstrasactionsAdmin
          open={openViewsTransactions}
          exit={handleCloseViewsDependents}
          callBackRefresh={RefreshTable}
          id={idRow}
        />
      )}
      {openExcel && (
        <ViewExcelDownload
          open={openExcel}
          id={rows}
          exit={handleCloseExcel}
          title="Se descargará el listado de transacciones actual."
        />
      )}
    </GridContainer>
  );
}
